import { useState } from 'react';
import toast from 'react-hot-toast';
import api from '../services/api';

const PublishWorkflow = ({ projectId, versionId, onPublished }) => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [reviewNotes, setReviewNotes] = useState('');
  const [reviewerUserId, setReviewerUserId] = useState('');
  const [reviewDeadline, setReviewDeadline] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const modalId = 'publish-workflow-modal';

  const handlePublish = async () => {
    if (!title.trim()) {
      toast.error('Title is required');
      return;
    }

    setSubmitting(true);
    try {
      const { data } = await api.post(`/api/projects/${projectId}/publish`, {
        source_version_id: Number(versionId),
        title,
        review_notes: reviewNotes,
      });
      if (reviewerUserId) {
        await api.put(`/api/published/${data.id}/assign-reviewer`, {
          reviewer_user_id: Number(reviewerUserId),
          review_deadline: reviewDeadline ? new Date(reviewDeadline).toISOString() : null,
        });
      }
      toast.success('Policy saved as draft');
      onPublished?.(data);
      setOpen(false);
      setTitle('');
      setReviewNotes('');
      setReviewerUserId('');
      setReviewDeadline('');
    } catch {
      toast.error('Failed to publish policy');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <button
        className="btn btn--primary"
        onClick={() => setOpen(true)}
        aria-expanded={open}
        aria-controls={modalId}
      >
        Publish
      </button>

      {open && (
        <div className="modal-overlay" role="dialog" aria-modal="true" id={modalId}>
          <div className="modal-content publish-workflow">
            <h3>Publish Policy Snapshot</h3>
            <div className="form-group">
              <label htmlFor="publish-title">Title</label>
              <input id="publish-title" value={title} onChange={(e) => setTitle(e.target.value)} />
            </div>
            <div className="form-group">
              <label htmlFor="publish-notes">Review notes</label>
              <textarea id="publish-notes" value={reviewNotes} onChange={(e) => setReviewNotes(e.target.value)} />
            </div>
            <div className="form-group">
              <label htmlFor="publish-reviewer">Assigned reviewer user ID (optional)</label>
              <input
                id="publish-reviewer"
                value={reviewerUserId}
                onChange={(e) => setReviewerUserId(e.target.value)}
                placeholder="e.g. 1"
              />
            </div>
            <div className="form-group">
              <label htmlFor="publish-deadline">Review deadline (optional)</label>
              <input
                id="publish-deadline"
                type="date"
                value={reviewDeadline}
                onChange={(e) => setReviewDeadline(e.target.value)}
              />
            </div>
            <div className="modal-actions">
              <button className="btn" onClick={() => setOpen(false)}>Cancel</button>
              <button className="btn btn--primary" onClick={handlePublish} disabled={submitting}>
                {submitting ? 'Publishing...' : 'Create Draft'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PublishWorkflow;
